import { setYouTubeJsLoaded, setYouTubePlayer, setYouTubePlaying } from "src/integrations/youtube/state"

export type LoadYouTubeIframeProps = {
  iframeParent: HTMLElement
  videoId: string
  autoPlay?: boolean
  mute?: boolean
  loop?: boolean
  enablejsapi?: boolean
}

export async function loadYouTubeIframe({ iframeParent, videoId, autoPlay, mute, loop }: LoadYouTubeIframeProps) {
  // https://developers.google.com/youtube/player_parameters#Parameters
  const params = new URLSearchParams()
  params.append("autoplay", "1")
  params.append("autoplay", autoPlay ? "1" : "0")
  params.append("controls", "1")
  params.append("loop", loop ? "1" : "0")
  params.append("modestbranding", "1")
  params.append("mute", mute ? "1" : "0")
  params.append("playlist", videoId)
  params.append("playsinline", "1")
  params.append("rel", "0")
  params.append("showinfo", "0")

  if (!window.YT?.Player) {
    await new Promise<void>((resolve, reject) => {
      const script = document.createElement("script")
      script.src = "https://www.youtube.com/iframe_api"
      script.async = true
      script.onload = () => {
        window.YT?.ready(resolve)
        setYouTubeJsLoaded()
      }
      script.onerror = reject
      iframeParent.append(script)
    })
  }

  if (window.YT?.Player) {
    const videoPlaceholder = document.createElement("div")
    iframeParent.append(videoPlaceholder)

    const player = new window.YT.Player(videoPlaceholder, {
      width: "100%",
      height: "100%",
      videoId: videoId,
      host: "https://www.youtube-nocookie.com",
      playerVars: Object.fromEntries(params.entries()),
      events: {
        // https://developers.google.com/youtube/iframe_api_reference#Events
        onReady: (event: any) => {
          if (autoPlay) {
            event.target.playVideo()
          }
        },
        onStateChange: (event: any) => {
          const playing = event.data === 1 || event.data === 3
          setYouTubePlaying(playing)
        },
      },
    })

    setYouTubePlayer(player)

    return
  }
}
